export default __webpack_public_path__ + "media/images/about/about-2.jpg";